import type { TFunction } from 'i18next';

import type { ValidatorMessage } from '@/helpers/validators';

export function getErrorTranslation(t: TFunction, value: ValidatorMessage) {
  if (typeof value === 'string') {
    return t(value);
  }

  const [key, options] = value;

  return t(key, options);
}

export function replaceErrorField(
  errors: { field: string; message: any }[],
  replace: { [field: string]: string }
) {
  return errors.map((error) => {
    const e = Object.keys(replace).find((k) => k === error.field);

    if (e == null) return error;

    return {
      ...error,
      field: replace[e],
    };
  });
}
